import apiClient from './api';

export type ServiceProviderDepositRefundRequestStatus = 'pending_review' | 'approved' | 'rejected';

export interface ServiceProviderDepositRefundRequestListParams {
  page?: number;
  pageSize?: number;
  keyword?: string;
  status?: ServiceProviderDepositRefundRequestStatus | 'all';
  startDate?: string;
  endDate?: string;
}

export interface ServiceProviderDepositRefundRequestItem {
  id: string;
  requestNo: string;
  providerId: string;
  providerName: string;
  providerPhone: string;
  amount: number;
  amountText: string;
  status: ServiceProviderDepositRefundRequestStatus | string;
  statusText: string;
  beforeAmount: number;
  afterAmount: number;
  beforeBalance: number;
  afterBalance: number;
  applyRemark: string;
  reviewRemark: string;
  reviewerId: string;
  reviewerName: string;
  requestedAt: string;
  reviewedAt: string;
  createdAt: string;
  updatedAt: string;
  withdrawableNow: number;
}

export interface ServiceProviderDepositRefundRequestListResponse {
  list: ServiceProviderDepositRefundRequestItem[];
  total: number;
  page: number;
  pageSize: number;
}

export interface ReviewDepositRefundRequest {
  action: 'approve' | 'reject';
  remark?: string;
}

export const listServiceProviderDepositRefundRequests = async (
  params?: ServiceProviderDepositRefundRequestListParams,
): Promise<ServiceProviderDepositRefundRequestListResponse> => {
  const response = await apiClient.get<ServiceProviderDepositRefundRequestListResponse>(
    '/service-provider-deposit-refund-requests',
    { params },
  );
  return response.data;
};

export const getServiceProviderDepositRefundRequestDetail = async (
  id: string,
): Promise<ServiceProviderDepositRefundRequestItem> => {
  const response = await apiClient.get<ServiceProviderDepositRefundRequestItem>(
    `/service-provider-deposit-refund-requests/${id}`,
  );
  return response.data;
};

export const reviewServiceProviderDepositRefundRequest = async (
  id: string,
  data: ReviewDepositRefundRequest,
): Promise<ServiceProviderDepositRefundRequestItem> => {
  const response = await apiClient.put<ServiceProviderDepositRefundRequestItem>(
    `/service-provider-deposit-refund-requests/${id}/review`,
    data,
  );
  return response.data;
};
